import { useMemo } from 'react';

/** Action sessions survive game navigation and reset with the account session. */
export function useNewActionsSession(account: string) {
  const { openedSessions } = useMemo(() => ({ account, openedSessions: new Set<string>() }), [account]);
  return { openedSessions };
}
